// FIXME circular dependency
// eslint-disable-next-line workspaces/require-dependency
import type { CollabManager } from '@databases/utils/redux/collab/collab-manager';

/**
 * This class is meant to manage the entire lifecycle of collab managers.
 * Currently, it stores a mapping of content IDs to collab managers.
 * In the future, we want this class to handle the creation of collab managers as well.

 */
export class CollabStateManager {
  #collabManagerMap: Map<string, CollabManager> = new Map();

  setCollabManager(contentId: string, collabManager: CollabManager): void {
    this.#collabManagerMap.set(contentId, collabManager);
  }

  getCollabManager(contentId: string): CollabManager | undefined {
    return this.#collabManagerMap.get(contentId);
  }

  // TODO not used right now, but we will eventually use it to properly remove
  // collab managers
  removeCollabManager(contentId: string): void {
    this.#collabManagerMap.delete(contentId);
  }

  closeInactiveSessions(currentContentId: string): void {
    for (const [contentId, manager] of this.#collabManagerMap.entries()) {
      if (contentId !== currentContentId) {
        manager.killSession();
      }
    }
  }
  listSessions(): string[] {
    return Array.from(this.#collabManagerMap.keys());
  }
}

export const collabStateManager = new CollabStateManager();
